var render = function render(){var _vm=this,_c=_vm._self._c;return _c('title-wrapper',{attrs:{"title":_vm.$t('components.activatePassword.title')}},[_c('v-container',{staticClass:"white pa-10"},[_c('set-account-password',{attrs:{"button-text":_vm.$t('components.activatePassword.buttonText'),"loading":_vm.loading},on:{"click":_vm.activateAccount}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }